import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ZWIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="ZW" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M0 1v10h16V1H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#272727"
          stroke="#E31D1C"
          strokeWidth={1.75}
          d="M16.875 4.125v3.75H-.875v-3.75h17.75Z"
        />
        <Path fill="#5EAA22" d="M16 10v2H0v-2h16Zm0-10v2H0V0h16Z" />
      </G>
      <Path
        fill="#F7FCFF"
        stroke="#272727"
        d="m.299-.401 8.165 6.076.546.406-.551.4-8.165 5.923-.794.576V-.995l.799.594Z"
      />
      <Mask
        id="c"
        width={11}
        height={16}
        x={-1}
        y={-2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          stroke="#fff"
          d="m.299-.401 8.165 6.076.546.406-.551.4-8.165 5.923-.794.576V-.995l.799.594Z"
        />
      </Mask>
      <G fillRule="evenodd" clipRule="evenodd" mask="url(#c)">
        <Path
          fill="#E31D1C"
          d="M3.74 7.139 1.85 8.664l.866-2.038-1.489-1.434h1.758l.721-1.73.766 1.73h1.755L4.66 6.626l.785 2.038L3.739 7.14Z"
        />
        <Path
          fill="#FECA00"
          d="M2.509 4.21s-.028-.066.134-.124c.162-.058.212-.182.338-.091.127.091.207-.092.243.17.037.264.137.678.137.678L5.005 6.08h-.31s-.48.706-.4 1.326c0 0-.332-.05-.782-.05s-.745.107-.745.107l-.26-.961s.095-.162.135-.292c.04-.13.208-.155.208-.258 0-.104-.165-.19-.083-.459.083-.268.083-1.07.083-1.07s-.26-.115-.208-.115c.053 0 .174-.096.087-.096H2.51Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
